import styles from './ProcessSteps.module.css';

const steps = [
  {
    id: 1,
    title: 'Conversa estratégica',
    description: 'Você entra em contato, e eu conheço sua empresa e seus objetivos.',
    badge: 'Foco no seu sucesso',
  },
  {
    id: 2,
    title: 'Proposta sob medida',
    description: 'Vou criar pelo menos 2 opções de orçamento para você escolher.',
    badge: 'Atendendo a todos',
  },
  {
    id: 3,
    title: 'Desenvolvimento ágil e preciso',
    description: 'Vou desenvolver um site com design e funcionalidades ideais.',
    badge: 'Cuidando de cada detalhe',
  },
  {
    id: 4,
    title: 'Entrega e suporte',
    description: 'Vou ativar o site, acompanhar o início e garantir todo suporte necessário.',
    badge: 'Pronto para impressionar',
  },
];

type ProcessStepsProps = {
  id?: string;
};

export default function ProcessSteps({ id }: ProcessStepsProps = {}) {
  return (
    <section id={id} className={styles.wrapper} aria-labelledby="process-heading">
      <div className={styles.container}>
        <header className={styles.header}>
          <span className={styles.subtitle}>Processos simples, rápido e eficiente</span>
          <h2 id="process-heading">
            Em <strong>4 passos</strong>, seu site <strong>estará pronto</strong> para impactar seu{' '}
            <strong>público-alvo!</strong>
          </h2>
        </header>

        <ol className={styles.stepGrid}>
          {steps.map((step) => (
            <li key={step.id} className={styles.stepCard}>
              <div className={styles.stepHeader}>
                <span className={styles.stepNumber}>{step.id}</span>
                <h3>{step.title}</h3>
              </div>
              <p>{step.description}</p>
              <div className={styles.badge} role="group" aria-label={`Reconhecimento: ${step.badge}`}>
                <span className={styles.badgeIcon} aria-hidden="true">✅</span>
                <span className={styles.badgeText}>{step.badge}</span>
              </div>
            </li>
          ))}
        </ol>

        <a
          className={styles.ctaButton}
          href="https://wa.me/5535999564940?text=Ol%C3%A1%21%20Acabei%20de%20visitar%20o%20site%20da%20DJ%20DevStudio%20e%20quero%20um%20or%C3%A7amento."
          target="_blank"
          rel="noreferrer"
        >
          Quero fazer um orçamento sem compromisso
        </a>
      </div>
    </section>
  );
}
